function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareBottomHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 181.931,
    height: 176.534,
    viewBox: "0 0 48.136 46.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M67.426 71.532h36.315c2.67 0 4.82 2.149 4.82 4.819v34.887c0 2.67-2.15 4.819-4.82 4.819H67.426c-2.67 0-4.819-2.15-4.819-4.82V76.352c0-2.67 2.15-4.82 4.82-4.82z",
    style: {
      fill: "#0967D2",
      fillOpacity: 1,
      stroke: "#0967D2",
      strokeWidth: 2.18258,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-61.516 -70.44)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.217 93.599h31.09a4.096 4.096 0 0 1 4.105 4.105v11.1a4.096 4.096 0 0 1-4.105 4.105h-31.09a4.096 4.096 0 0 1-4.105-4.105v-11.1a4.096 4.096 0 0 1 4.105-4.105z",
    style: {
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.32921,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-61.516 -70.44)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareBottomHalf);
export default __webpack_public_path__ + "static/media/square_bottom_half.aaa363fc22e5c37ee96cf0025cee481d.svg";
export { ForwardRef as ReactComponent };